import gql from 'graphql-tag';

const getBrandPresetQuery = gql`
  query getBrandPreset($brandPresetId: String!) {
  getBrandPreset(brandPresetId: $brandPresetId) {
    brandPresetId
    name
    description
    defaultLogo
    logos
    defaultColorName
    defaultColorHexCode
    googleFilestream
    proBrandingStatus
    colors {
      colorName
      hexCode
    }
    safeWebFonts
    fonts
    additionalFiles
    thumbnail
  }
}
`;

export default (() => ({
  query: getBrandPresetQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: (brandPresetId) => ({
    brandPresetId
  })
}));